import { createSlice } from '@reduxjs/toolkit';
import { findUserWishlist } from './api';
import { initialState } from './api/interface';

const userWishlistSlice = createSlice({
  name: 'userWishlist',
  initialState,
  reducers: {
    setLimit: (state, action) => {
      state.limit = action.payload.limit;
      state.status = 'idle';
    },
    setSkip: (state, action) => {
      state.skip = action.payload.skip;
      state.status = 'idle';
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload.currentPage;
    },
    setStatus: (state, action) => {
      state.status = action.payload.status;
    },
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(findUserWishlist.pending, (state) => {
      state.isLoading = true;
      state.status = 'pending';
    });
    builder.addCase(findUserWishlist.fulfilled, (state, action) => {
      state.data = action.payload.data || [];
      state.totalRecords = action.payload.total || 0;
      state.isError = false;
      state.isSuccess = true;
      state.isLoading = false;
      state.status = 'succeeded';
    });
    builder.addCase(findUserWishlist.rejected, (state) => {
      state.data = [];
      state.totalRecords = 0;
      state.isLoading = false;
      state.isError = true;
      state.isSuccess = false;
      state.status = 'failed';
    });
  },
});

export const { setLimit, setSkip, setCurrentPage, setStatus, reset } =
  userWishlistSlice.actions;
export default userWishlistSlice.reducer;
